<!-- BOARDS -->
<div id="boards" class="fuse-white" fxLayout="column" fxLayoutAlign="start center" fxFlex fusePerfectScrollbar>

  <!-- Welcome Section -->
  <div class="flex flex-col md:flex-row items-center justify-center mt-12 md:mt-[200px] space-y-4 md:space-y-0 md:space-x-4 text-center">
    <div class="logo-section pt-24" fxLayout="row" fxLayoutAlign="center center"
    [@animate]="{value:'*',params:{delay:'150ms'}}">
 <div class="yali-logo">
   <img src="assets/images/logos/{{municipio}}.png" alt="Logo Yali">
   <div class="logo-slogan">
     <p>Multiplicamos</p>
     <p>la eficiencia</p>
   </div>
 </div>
</div>
    <div>
        <h1 class="text-2xl md:text-3xl font-bold text-black">
            ¡Hola, <span class="text-pimary">{{User.nomb}} {{User.pate}}</span>! Es un placer recibirte.
        </h1>
        <p class="text-base text-gray-600" *ngIf="typeUser !== 'autoridad' && typeUser !== 'ciudadano'">
            Que tengas una jornada productiva.
        </p>
    </div>
</div>

  <!-- BOARD LIST -->
  <section *ngFor="let option of boards" fxFlex="0 0 auto" fxLayout="column wrap" fxLayoutAlign="center start">
    <div class="board-list" fxFlex="0 0 auto" fxLayout="row wrap" fxLayoutAlign="center center"
        [@animateStagger]="{value:'50'}">
        
        <!-- Omit title if just showing one category of boards -->
        <!--
        
        -->
        <div class="board-list-item-title board-title {{option.id}}"
            fxLayout="column" fxLayoutAlign="center center"
            [@animate]="{value:'*',params:{y:'100%'}}">
          <mat-icon class="s-36">{{option.icon}}</mat-icon>
          <div class="board-name-title">{{option.name}}</div>
        </div>
        <!-- BOARD ITEMS -->
        <div class="board-list-item board-item" *ngFor="let board of option.boards"
              [routerLink]="[board.path]" routerLinkActive="router-link-active" 
              fxLayout="column" fxLayoutAlign="center center"
              [@animate]="{value:'*',params:{y:'100%'}}">
              <div class="icon-container">
                <mat-icon class="s-28">{{board.icon}}</mat-icon>
              </div>
              <div class="board-name">{{board.name}}</div>
          </div>
        <!-- / BOARD ITEMS -->
    </div>
  </section>
  <!-- / BOARD LIST -->
</div>
<!-- / BOARDS -->